 
import { IServerSideGetRowsParams } from 'ag-grid-community'
import { useAppDispatch, useAppSelector } from 'appState/store'
import { ObGrid } from '@outbound-ai/ursa'
import {
  CLAIMS_FILE_COLUMN,
  ROW_MODEL_TYPE,
} from 'features/claims/components/ClaimsTable/Internal/ClaimsTableConstants'
import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'

import { updateCurrentBatch } from '../autoCheckSlice'
import { BatchTabType } from '../types'
import { NoContentFOrNoEOB } from '../utils'
import { createBatchServerSideDataSource } from '../utils/grid'
import { EobReviewConfig } from './AutoCheckGrid/gridConfig'

export const EOBReview = () => {
  const dispatch = useAppDispatch()
  const { root, refresh } = useAppSelector((state) => state.batch)
  const [gridApi, setGridApi] = useState<any>(null)

  const onGridReady = async (params: IServerSideGetRowsParams) => {
    setGridApi(params)

    dispatch(updateCurrentBatch({ root: BatchTabType.EOBReview }))
    const dataSource = createBatchServerSideDataSource(BatchTabType.EOBReview)
    params.api.setGridOption('serverSideDatasource', dataSource)
  }

  useEffect(() => {
    if (refresh && gridApi) {
      const dataSource = createBatchServerSideDataSource(root)
      gridApi.api.setGridOption('serverSideDatasource', dataSource)
      dispatch(updateCurrentBatch({ root: BatchTabType.EOBReview, refresh: false }))
    }
  }, [refresh, root])

  const onFirstDataRendered = (params: any) => {
    params.api.sizeColumnsToFit()
    if (window.innerWidth > 1600) {
      params.api.sizeColumnsToFit()
    } else {
      window.setTimeout(() => {
        const colIds = params.api.getColumns().map((col: any) => col.getColId())
        params.api.autoSizeColumns(colIds)
      })
    }
  }

  return (
    <Div>
      <div className="grid">
        <ObGrid
          reactiveCustomComponents={true}
          columnDefs={EobReviewConfig as any}
          rowModelType={ROW_MODEL_TYPE}
          defaultColDef={CLAIMS_FILE_COLUMN as any}
          onGridReady={onGridReady as any}
          rowHeight={50}
          paginationPageSize={20}
          cacheBlockSize={20}
          noRowsOverlayComponent={NoContentFOrNoEOB}
          onFirstDataRendered={onFirstDataRendered}
        ></ObGrid>
      </div>
    </Div>
  )
}

const Div = styled.div`
  padding: 1.5rem 1rem 0 0;
  overflow: hidden;
  position: relative;
  .grid {
    ${({ theme }) => css`
      height: calc(
        100vh - ${theme.constants.navbarHeight} - ${theme.constants.pageTitleHeight} -
          ${theme.constants.tableHeadHeight} - 90px
      );
    `}
  }
  h2 {
    font-family: ${({ theme }) => theme.fontFamily.milliard};
    ${({ theme }) => theme.typography.h5.bold};
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary.darker};
  }
`
